import script from "./Form29Section.vue?vue&type=script&setup=true&lang=js"
export * from "./Form29Section.vue?vue&type=script&setup=true&lang=js"

import "./Form29Section.vue?vue&type=style&index=0&id=5b8829c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b8829c8"]])

export default __exports__